import { Tag } from "thunk-core";

export const tagsToString = (tags: Tag[]) => {
  return tags
    .sort((x, y) => x.title.toLowerCase().localeCompare(y.title.toLowerCase()))
    .map((x) => x.title)
    .join(", ");
};
